var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%","min-height":"100vh"},attrs:{"element-loading-text":"请等待..."}})}
var staticRenderFns = []

export { render, staticRenderFns }